import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=13a82584&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=13a82584&prod&lang=scss"
import style1 from "./index2.vue?vue&type=style&index=1&id=13a82584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a82584",
  null
  
)

export default component.exports